import * as React from "react";
import { useScreenSize } from "./useScreenSize";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface MobileOnlyProps {
  children?: JSX.Element | JSX.Element[];
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
/***
 * This Higher Order Component wrappes mobile-only content, and
 * @param props
 * @constructor
 */
export const MobileOnly = React.memo(({ ...props }: MobileOnlyProps) => {
  const { isMobile } = useScreenSize();
  if (!isMobile) return null;
  return <>{props.children}</>;
});
